// extracted by mini-css-extract-plugin
module.exports = {"responseItem":"ResponsesCard__responseItem___RCDYX","responseItemLabel":"ResponsesCard__responseItemLabel___gO6Sf","responseItemValue":"ResponsesCard__responseItemValue___DOuEM"};